import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { IVoucher } from '../models/Voucher';
import useApiHelper from '../hooks/useApiHelper';


export default function useSingleVoucher(voucherId: string) {
  const { get, patch, del } = useApiHelper();
  const queryClient = useQueryClient();

  const voucher = useQuery({
    queryKey: ["voucher", voucherId],
    queryFn: () => get<IVoucher>(`/voucher/${voucherId}`),
  });

  const update = useMutation(
    (voucher: IVoucher) => patch(`/voucher/${voucher.id}`, voucher),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["vouchers"]);
      },
    }
  );

  const remove = useMutation(
    (voucherId: string) => del(`/voucher/${voucherId}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["vouchers"]);
      },
    }
  );

  return {
    voucher,
    update,
    remove
  };
}